export function queryStringToRecord(
  queryString: URLSearchParams,
): Record<string, string> {
  const params: Record<string, string> = {};
  queryString.forEach((value, key) => (params[key] = value));
  return params;
}

export function formDataToQueryString(formData: FormData): URLSearchParams {
  const queryString = new URLSearchParams();
  formData.forEach((value: any, key: any) => {
    queryString.append(key, value);
  });
  return queryString;
}

export function appendToFormData(
  formData: FormData,
  object: Record<string, any>,
) {
  for (const [key, value] of Object.entries(object)) {
    formData.append(key, value);
  }
  return formData;
}

export function generateSearchConfig() {
  const data: Record<string, any> = {};
  // @ts-ignore
  for (const [key, value] of Object.entries(window.searched ?? {})) {
    data[key] = value;
  }
  return data;
}
